import { css } from "@emotion/css";
import { withBasicStyles } from "@/styles/common";

export const useStyles = withBasicStyles(() => ({
  sources: css`
    position: relative;
  `,

  sourcesTitleWrapper: css`
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    font-size: 14px;
    color: #888;
    line-height: 1.5;
    cursor: pointer;
    margin-bottom: 12px;
    width: fit-content;
  `,

  sourcesTitleDownIcon: css`
    font-size: 12px;
    transition: transform 0.3s ease;
  `,

  sourcesTitleDownIconExpanded: css`
    transform: rotate(90deg);
  `,

  sourcesIconPositionEnd: css`
    .sources-title-down-icon {
      order: 1;
    }
  `,

  sourcesList: css`
    list-style: none;
    margin: 0;
    padding: 0;
    ul, ol {
      margin: 0;
      padding: 0;
      list-style: none;
    }
  `,

  sourcesListItem: css`
    margin-bottom: 8px;
  `,

  sourcesLink: css`
    color: #333;
    display: flex;
    gap: 4px;
    text-decoration: none;
    &:hover {
      color: #1677ff;
    }
  `,

  sourcesLinkIcon: css`
    flex-shrink: 0;
  `,

  sourcesLinkTitle: css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,

  sourcesContent: css`
    overflow: hidden;
    transition: all 0.3s ease;
  `,

  sourcesContentHidden: css`
    display: none;
  `,

  sourcesInline: css`
    display: inline-flex;
    .sources-title-wrapper {
      background: #f5f5f5;
      border-radius: 10px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      color: #888;
      font-weight: 400;
      padding-inline: 6px;
      padding-block: 0;
      margin-inline: 4px;
      margin-block: 0;
    }
  `,

  // ========== Carousel 相关 ==========
  carouselWrapper: css`
    min-width: 260px;
  `,

  carouselTitle: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  `,

  carouselBtnWrapper: css`
    display: flex;
    gap: 4px;
  `,

  carouselBtn: css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    height: 32px;
    width: 32px;
    border-radius: 6px;
    transition: background 0.2s ease;
    &:not(.carousel-btn-disabled):hover {
      background: #f5f5f5;
    }
  `,

  carouselBtnDisabled: css`
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  `,

  carouselPage: css`
    font-size: 12px;
    color: #888;
  `,

  carouselItem: css`
    padding: 8px;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 1.5;
    cursor: pointer;
  `,

  carouselItemTitleWrapper: css`
    display: flex;
    gap: 4px;
    align-items: center;
  `,

  carouselItemTitle: css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,

  carouselItemDescription: css`
    opacity: 0.8;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    text-overflow: ellipsis;
    margin-top: 4px;
    font-size: 12px;
    color: #888;
  `,
}));

export default useStyles;